@if (hasCompetences(occupationalProfile)) {
    <!-- vaardigheden -->
    <div class="o-wrapper">
      <section class="o-2-col -sidearea">
        <div class="c-skills">
          @if (hasEssentialCompetences(occupationalProfile)) {
            <occupational-profile-competence elementId="belangrijkste-vaardigheden" [title]="'Belangrijkste vaardigheden'" [competences]="occupationalProfile.essentialCompetences"></occupational-profile-competence>
          }
          @if (hasOptionalCompetences(occupationalProfile)) {
            <occupational-profile-competence elementId="aanvullende-vaardigheden" [title]="'Aanvullende vaardigheden'" [competences]="occupationalProfile.optionalCompetences"></occupational-profile-competence>
          }
          @if (hasSoftSkills(occupationalProfile)) {
            <occupational-profile-soft-skill id="persoonlijke-vaardigheden" [title]="'Persoonlijke vaardigheden'" [softSkills]="occupationalProfile.softSkills"></occupational-profile-soft-skill>
          }
        </div>
        <div class="c-skills__img">
          <img src="/cdn/img/beroepenfiche/skills.svg" alt="">
        </div>
      </section>
    </div>
}
